import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";

class GoHome extends React.Component {
  render() {
    return (
      <div
        className="goHome"
        style={{ position: "absolute", top: "15px", left: "15px" }}
      >
        <button
          style={{ borderRadius: "20px",padding:"10px 20px",display:"flex",boxShadow:`0px 4px 15px rgba(7, 42, 68, 0.1)`,backgroundColor:"white",border:"1px solid #ffffff",cursor:"pointer" }}
          onClick={() => {
            this.props.history.push("/");
          }}
        >
          <i className="material-icons">arrow_back</i>
          <span>Back to Homepage</span>
        </button>
      </div>
    );
  }
}

export default withRouter(GoHome);
